import React from "react"

import { StyledPillsContainer, StyledPill } from "./partials"

export interface PillsProps {
  skills: Array<string>
  pill_theme: string
}

export const PillsCmp: React.FC<PillsProps> = ({ skills, pill_theme }) => (
  <StyledPillsContainer>
    {skills &&
      skills.map((s) => (
        <StyledPill pill_theme={pill_theme}>
          <p>{s}</p>
        </StyledPill>
      ))}
  </StyledPillsContainer>
)
